module.exports = __webpack_public_path__ + "static/media/177-colombia.d4e2f501.svg";